import dayjs from 'untils/dateTime/day';

export const roundToNearestTime = (time, unit, amount) => {
  const dateTime = dayjs(time);

  const mod = amount - (dateTime.get(unit) % amount);
  if (mod >= amount) {
    return dateTime.add(amount, unit).startOf(unit);
  }

  return dateTime.add(mod, unit).startOf(unit);
};
